module.exports = __webpack_public_path__ + "img/hammer-sickle.3fea563c.svg";